import { useMemo } from 'react';

export const useExtractVisualAIEvidences = (diagnostics: [string, any][]) => {
  const cameraDiagnostics = useMemo(() => {
    if (!diagnostics?.length) return [];

    return diagnostics
      .flatMap(([timestamp, data]: [string, any]) => {
        return data.assets[0].components
          .flatMap(({ component_id, diagnostics }: any) =>
            diagnostics.flatMap(({ fault_type, sources_info }: any) =>
              sources_info
                .filter(({ source_type }: any) => source_type.toLowerCase() === 'camera')
                .map(({ source_type, health_status, evidence_resource_id, evidence_text }: any) => ({
                  timestamp,
                  uniqueId: `${evidence_resource_id}_${timestamp}`,
                  fault_type,
                  component_id,
                  source_type,
                  health_status,
                  evidence_resource_id,
                  evidence_text,
                  belt_position: fault_type?.toLowerCase().includes('belt')
                    ? fault_type.toLowerCase().includes('left')
                      ? 'left'
                      : fault_type.toLowerCase().includes('right')
                      ? 'right'
                      : 'both'
                    : null,
                }))
            )
          )
          .filter((item: any) => item.health_status !== 'na' && item.evidence_resource_id);
      })
      .filter(Boolean);
  }, [diagnostics]);
  return { cameraDiagnostics };
};
